import { render } from "./submitLog.vue?vue&type=template&id=2f2cc3ca"
import script from "./submitLog.vue?vue&type=script&lang=js"
export * from "./submitLog.vue?vue&type=script&lang=js"

import exportComponent from "G:\\frontend\\dse-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__